module.exports = __webpack_public_path__ + "logo-pando.e1587a557dd32040a9e1.svg";